import type { ImportRunState } from './types';

export type RunSummary = {
  success: number;
  failed: number;
  stopped: number;
  uniqueCompanyIds: number[];
};

export const computeRunSummary = (run: ImportRunState): RunSummary => {
  let success = 0;
  let failed = 0;
  let stopped = 0;
  const companyIdSet = new Set<number>();

  for (const item of run.items) {
    if (item.status === 'success') {
      success += 1;
      companyIdSet.add(item.targetCompanyId);
    } else if (item.status === 'failed') {
      failed += 1;
    } else if (item.status === 'stopped') {
      stopped += 1;
    }
  }

  return { success, failed, stopped, uniqueCompanyIds: Array.from(companyIdSet) };
};
